import type { Translations } from '../../../types'

const profilePanelsMessages: Translations = {
  "profile.panels.contact.title": "Panoramica account",
  "profile.panels.contact.description": "Gestisci i dati principali del tuo profilo amministratore.",
  "profile.panels.customer.profile.title": "Profilo cliente",
  "profile.panels.customer.profile.description": "Dati personali, telefono e codice fiscale.",
  "profile.panels.preferences.title": "Preferenze",
  "profile.panels.preferences.description": "Lingua interfaccia e preferenze operative.",
  "profile.panels.smtp.title": "Configurazione email (SMTP)",
  "profile.panels.smtp.description": "Configura SMTP runtime e diagnostica invio email operative.",
  "profile.panels.smtp.meta": "Capability email",
  "profile.panels.customer.addresses.title": "Indirizzi e fatturazione",
  "profile.panels.customer.addresses.description": "Residenza, indirizzo di spedizione e fatturazione.",
  "profile.panels.security.title": "Sicurezza account",
  "profile.panels.security.description": "Password, accessi e 2FA amministrativa.",
  "profile.panels.security.meta": "Password + 2FA",
  "profile.panels.sessions.title": "Sessioni e dispositivi",
  "profile.panels.sessions.description.none": "Nessun dispositivo da confermare",
  "profile.panels.sessions.description.single": "1 dispositivo collegato",
  "profile.panels.sessions.description.many": "{{count}} dispositivi collegati",
  "profile.panels.sessions.meta": "Ultimo accesso {{date}}",
  "profile.panels.team.title": "Team e ruoli",
  "profile.panels.team.description": "Invita nuovi membri e assegna permessi.",
  "profile.panels.team.meta.none": "Nessun membro attivo",
  "profile.panels.team.meta.single": "1 membro",
  "profile.panels.team.meta.many": "{{count}} membri",
  "profile.panels.danger.title": "Privacy",
  "profile.panels.danger.description": "Gestisci consensi, export dati e ciclo vita account.",
  "profile.panels.danger.meta": "GDPR-ready.",
}

export default profilePanelsMessages
